// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2riG5","loaderOuter":"PageOverlayLoader_loaderOuter__1TQXy"};